/* eslint-disable react/prop-types */
import React from "react";

const MedicalFlashcardsIcon = ({
  size = 30,
  color = "currentColor",
  className
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Back card */}
      <rect
        x="62"
        y="52"
        width="100"
        height="120"
        rx="10"
        fill="white"
        stroke={color}
        strokeWidth="4"
      />

      {/* Middle card */}
      <rect
        x="54"
        y="44"
        width="100"
        height="120"
        rx="10"
        fill="white"
        stroke={color}
        strokeWidth="4"
      />

      {/* Front card */}
      <rect
        x="44"
        y="36"
        width="100"
        height="120"
        rx="10"
        fill="white"
        stroke={color}
        strokeWidth="4"
      />

      {/* Divider line */}
      <line
        x1="52"
        y1="100"
        x2="136"
        y2="100"
        stroke={color}
        strokeWidth="3.5"
        strokeLinecap="round"
      />

      {/* Medical cross — filled */}
      <path
        d="M87 56 Q87 52 91 52 H103 Q107 52 107 56 V63 H114 Q118 63 118 67 V79 Q118 83 114 83 H107 V90 Q107 94 103 94 H91 Q87 94 87 90 V83 H80 Q76 83 76 79 V67 Q76 63 80 63 H87 Z"
        fill={color}
      />

      {/* Text lines */}
      <line
        x1="56"
        y1="113"
        x2="128"
        y2="113"
        stroke={color}
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <line
        x1="56"
        y1="124"
        x2="120"
        y2="124"
        stroke={color}
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <line
        x1="56"
        y1="135"
        x2="110"
        y2="135"
        stroke={color}
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default MedicalFlashcardsIcon;
